/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.3.1(bac26893f27c9ed9e67951f467120ce782f58226)
 * Released under the MIT license
 * https://github.com/Microsoft/vscode/blob/master/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/languages/json/common/jsonWorker.nls.zh-cn", {
	"vs/base/common/http": [
		"Bad request. The request cannot be fulfilled due to bad syntax.",
		"Unauthorized. The server is refusing to respond.",
		"Forbidden. The server is refusing to respond.",
		"Not Found. The requested location could not be found.",
		"Method not allowed. A request was made using a request method not supported by that location.",
		"Not Acceptable. The server can only generate a response that is not accepted by the client.",
		"Proxy Authentication Required. The client must first authenticate itself with the proxy.",
		"Request Timeout. The server timed out waiting for the request.",
		"Conflict. The request could not be completed because of a conflict in the request.",
		"Gone. The requested page is no longer available.",
		"Length Required. The \"Content-Length\" is not defined.",
		"Precondition Failed. The precondition given in the request evaluated to false by the server.",
		"Request Entity Too Large. The server will not accept the request, because the request entity is too large.",
		"Request-URI Too Long. The server will not accept the request, because the URL is too long.",
		"Unsupported Media Type. The server will not accept the request, because the media type is not supported.",
		"Internal Server Error.",
		"Not Implemented. The server either does not recognize the request method, or it lacks the ability to fulfill the request.",
		"Service Unavailable. The server is currently unavailable (overloaded or down).",
		"HTTP status code {0}",
	],
	"vs/languages/json/common/contributions/bowerJSONContribution": [
		"默认 bower.json",
		"对 Bower 存储库发出的请求失败: {0}",
		"对 Bower 存储库发出的请求失败: {0}",
		"{0}",
	],
	"vs/languages/json/common/contributions/globPatternContribution": [
		"按扩展名的文件",
		"与具有特定文件扩展名的所有文件匹配。",
		"带有多个扩展名的文件",
		"与具有任意文件扩展名的所有文件匹配。",
		"具有同级文件的文件(按名称)",
		"与具有名称相同但扩展名不同的同级文件的文件匹配。",
		"按名称的文件夹(顶级)",
		"与具有特定名称的顶级文件夹匹配。",
		"使用多个名称的文件夹(顶级)",
		"与多个顶级文件夹匹配。",
		"按名称的文件夹(任意位置)",
		"与任意位置具有特定名称的文件夹匹配。",
		"True",
		"启用该模式。",
		"False",
		"禁用该模式。",
		"具有同级文件的文件(按名称)",
		"与具有名称相同但扩展名不同的同级文件的文件匹配。",
	],
	"vs/languages/json/common/contributions/packageJSONContribution": [
		"默认 package.json",
		"对 NPM 存储库发出的请求失败: {0}",
		"对 NPM 存储库发出的请求失败: {0}",
		"包的当前最新版本",
		"与最新的主要版本(1.x.x)匹配",
		"与最新的次要版本(1.2.x)匹配",
		"{0}",
		"最新版本: {0}",
	],
	"vs/languages/json/common/contributions/projectJSONContribution": [
		"默认 project.json",
		"对 NuGet 存储库发出的请求失败: {0}",
		"对 NuGet 存储库发出的请求失败: {0}",
		"包的当前最新版本",
		"{0}",
		"最新版本: {0}",
	],
	"vs/languages/json/common/jsonIntellisense": [
		"默认值",
	],
	"vs/languages/json/common/jsonSchemaService": [
		"Unable to load schema from \'{0}\': No content.",
		"Unable to parse content from \'{0}\': {1}.",
		"无法从 \'{0}\': {1} 加载架构。",
		"$ref \'{0}\' in {1} can not be resolved.",
		"Problems loading reference \'{0}\': {1}",
	],
	"vs/languages/json/common/parser/jsonParser": [
		"错误类型。预期为 {0} 的一种",
		"错误类型。预期为“{0}”",
		"匹配不允许的架构。",
		"当只有一个必须验证时，匹配多个架构。",
		"值不是一个可接受的值。有效值为: {0}",
		"根据架构，数组项目过多。预期为 {0} 或更少",
		"数组拥有的项目过少。预期为 {0} 或更多",
		"数组拥有的项目过多。预期为 {0} 或更少",
		"数组有重复的项目",
		"值不能被 {0} 整除",
		"值低于 {0} 的专有最小值",
		"值低于 {0} 的最小值",
		"值超过了 {0} 的专有最大值",
		"值超过了 {0} 的最大值",
		"字符串比最小长度短",
		"字符串比最大长度短",
		"字符串不匹配“{0}”的模式",
		"缺少属性“{0}”",
		"不允许使用属性 {0}。",
		"对象拥有比 {0} 限制更多的属性",
		"对象拥有比 {0} 需要的数量更少的属性",
		"对象缺少属性 {1} 要求的属性 {0}",
		"字符串中的 Unicode 序列无效",
		"字符串中的转义字符无效",
		"意外的数字结尾",
		"意外的注释结尾",
		"意外的字符串结尾",
		"需要值",
		"需要逗号或右中括号",
		"属性关键字必须用双引号括起来",
		"重复对象键",
		"需要冒号",
		"需要值",
		"预期的属性",
		"需要逗号或右大括号",
		"数字格式无效",
		"数字格式无效",
		"预期的 JSON 对象、数组或文本",
		"预期的文件结尾",
	]
});